import { Skeleton } from '@mui/material';
import { Box } from 'shared/mui/Box';

export const MerchantsShowCredentialsFormSkeleton: React.FC = () => (
  <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
    <Box sx={{ width: '396px', gap: '20px', display: 'flex', flexDirection: 'column' }}>
      <Skeleton height={40} variant="rounded" />
      <Skeleton height={40} variant="rounded" />
      <Skeleton height={120} variant="rounded" />
    </Box>
    <Box sx={{ width: '814px', display: 'flex' }}>
      <Skeleton height="100%" variant="rounded" width="100%" />
    </Box>
  </Box>
);
